import { useEffect, useState } from "react";
import {
  getAllQuestionDataService,
  getBusinessRulesDataService,
  getDiaryPageData,
  getPatientAttributeConfigurationDataService,
  getQuestionaireTypeDataServide,
  getSubmitActionParametersDataService,
} from "./services/dataService";
import SettingsIcon from "@mui/icons-material/Settings";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  BUSINESS_DATA,
  CHOICES_DATA,
  EDIT_OPTIONS,
  OPEN_ENDED_OPTIONS,
  PAGE_CONTAINER_OPTIONS,
  SAS_DATA_TYPES,
  STUDY_FILES_OPTIONS,
} from "./data";
import ManageChoice from "../ManageChoices/manageChoiceList";
import { useNavigate } from "react-router";
import { Tab, Tabs } from "@mui/material";
import { TabPanel } from "./helper";
import CalculationControlComp from "./CalculationControlComp";

export default function QuestionnaireSettings({
  survey,
  selectedElement,
  questionnaireId,
  onSurveyChange,
}) {
  const navigate = useNavigate();
  const questionId = selectedElement.current?.id;
  const questionName = selectedElement.current?.name;

  console.log("selectedName", questionName);
  const [activeTab, setActiveTab] = useState(0);
  const [selectedUid, setSelectedUid] = useState("");
  const [recieveId, setReceievedId] = useState(null);
  const [showManageChoices, setShowManageChoices] = useState("");

  const [elements, setElements] = useState({
    diaryPageOptions: [],
    allQuestionsTypeData: [],
    allLanguageData: [],
    allChoicesData: [],
    patientAttributesData: [],
    submitActionData: [],
    questionnaireTypeData: [],
    businessRulesData: [],
    selectedDiaryPage: "",
    selectedQuestionType: "",
    exportDisplayName: "",
    exportDisplayOrder: "",
    selectedSasDataType: "",
    sasLabel: "",
    sdtmCode: "",
    sdtmText: "",
    summaryDisplayText: "",
    description: "",
    sequenceNumber: "",
    groupNumber: "",
    selectedPatientAttribute: "",
    selectedSubmitAction: "",
    selectedLanguage: "",
    selectedStudyFile: "",
    minValueTextKeyText: "",
    maxValueDisplayText: "",
    inputDisplayText: "",
    translationKey: "",
    internalName: "",
    selectedQuestionnaireType: "",
    selectedBusinessRule: "",
    selectedOpenEnded: "",
    selectedDisplayProperty: "",
    selectedEnabledQuestionnaire: "",
    previousDayEntry: "",
    previousDayEdit: "",
    number: "",
    footerText: "",
    active: false,
    autoResizeChoice: false,
    keepQuestionTextFixed: false,
    displayOnConfirmation: false,
    isInstruction: false,
    landScapeOrientation: false,
    isBlinded: false,
    displaySummaryScore: false,
    isDropdownNavigationEnabled: false,
    validateQuestionnaire: false,
    promptIncompletePages: false,
    enforcePreviousDaysEntry: false,
    allowEdit: false,
    isHandwritingEnabled: false,
    isScrollEnabled: false,
  });

  const excludeFields = [
    "diaryPageOptions",
    "allQuestionsTypeData",
    "allLanguageData",
    "allChoicesData",
    "patientAttributesData",
    "submitActionData",
    "questionnaireTypeData",
    "businessRulesData",
  ];

  const {
    diaryPageOptions,
    selectedDiaryPage,
    selectedQuestionType,
    patientAttributesData,
    allChoicesData,
    allLanguageData,
    submitActionData,
    allQuestionsTypeData,
    questionnaireTypeData,
    businessRulesData,
    exportDisplayName,
    exportDisplayOrder,
    selectedSasDataType,
    sasLabel,
    sdtmCode,
    sdtmText,
    summaryDisplayText,
    description,
    sequenceNumber,
    groupNumber,
    selectedPatientAttribute,
    selectedSubmitAction,
    selectedLanguage,
    selectedStudyFile,
    minValueTextKeyText,
    maxValueDisplayText,
    inputDisplayText,
    translationKey,
    internalName,
    selectedQuestionnaireType,
    selectedBusinessRule,
    selectedOpenEnded,
    selectedDisplayProperty,
    selectedEnabledQuestionnaire,
    previousDayEntry,
    number,
    footerText,
    previousDayEdit,
    active,
    landScapeOrientation,
  } = elements;

  const filterQuestionnaireForElements = (data, excludeFields, elements) => {
    if (!data) return {};

    return Object.fromEntries(
      Object.entries(data).filter(
        ([key]) =>
          !excludeFields.includes(key) &&
          Object.prototype.hasOwnProperty.call(elements, key),
      ),
    );
  };

  useEffect(() => {
    if (questionnaireId) {
      getDiaryPageOptions(questionnaireId);
      getAllQuestionData();
      getPatientAttributesData();
      getSubmitActionData(questionnaireId);
      getQuestionnaireTypeData(questionnaireId);
      getBusinessRulesData();
    }
  }, [questionnaireId]);

  useEffect(() => {
    if (!questionName || !survey?.pages) return;

    let foundObj = null;

    if (questionName.startsWith("page")) {
      foundObj = survey.pages.find((page) => page.name === questionName);
    } else {
      foundObj = survey.pages
        .flatMap((page) => page.elements || [])
        .find((ele) => ele.id === questionName);
    }

    if (!foundObj?.questionnaireJson) {
      setElements((prev) => ({
        ...prev,
        ...Object.fromEntries(
          Object.keys(prev)
            .filter((key) => !excludeFields.includes(key))
            .map((key) => [key, ""]),
        ),
      }));
    }

    const hydratedValues = filterQuestionnaireForElements(
      foundObj?.questionnaireJson,
      excludeFields,
      elements,
    );

    // console.log(foundObj, "FoundObj");
    if (foundObj?.uid) {
      setSelectedUid(foundObj.uid);
    }

    if (foundObj && foundObj?.receivedId) {
      console.log("I am here", foundObj);
      setReceievedId(foundObj?.receivedId);
    }

    if (foundObj?.type === "dropdown") {
      setShowManageChoices(true);
    } else {
      setShowManageChoices(false);
    }

    setElements((prev) => ({
      ...prev,
      ...hydratedValues,
    }));
  }, [questionName, survey]);

  console.log("Receu", recieveId);

  const updateActiveTab = (event, newValue) => {
    event.preventDefault();
    setActiveTab(newValue);
  };

  const getDiaryPageOptions = async (questionnaireId) => {
    const res = await getDiaryPageData(questionnaireId);
    if (res?.data?.status == "Success") {
      setElements((prev) => ({
        ...prev,
        diaryPageOptions: res.data.result,
      }));
    }
  };

  const getAllQuestionData = async () => {
    const res = await getAllQuestionDataService();
    if (res?.data?.status == "Success") {
      setElements((prev) => ({
        ...prev,
        allQuestionsTypeData: res.data.result.allQuestionTypes,
        allLanguageData: res.data.result.languageList,
        allChoicesData: res.data.result.choiceDisplayTypesData,
      }));
    }
  };

  const getPatientAttributesData = async () => {
    const res = await getPatientAttributeConfigurationDataService();
    if (res?.data?.status == "Success") {
      setElements((prev) => ({
        ...prev,
        patientAttributesData: res.data.result,
      }));
    }
  };

  const getSubmitActionData = async (questionnaireId) => {
    const res = await getSubmitActionParametersDataService(questionnaireId);
    if (res?.data?.status == "Success") {
      setElements((prev) => ({
        ...prev,
        submitActionData: res.data.result,
      }));
    }
  };

  const getQuestionnaireTypeData = async (questionnaireId) => {
    const res = await getQuestionaireTypeDataServide(questionnaireId);
    if (res?.data?.status == "Success") {
      setElements((prev) => ({
        ...prev,
        questionnaireTypeData: res.data.result?.questionnaireType,
      }));
    }
  };

  const getBusinessRulesData = async () => {
    const res = await getBusinessRulesDataService();
    if (res?.data?.status == "Success") {
      setElements((prev) => ({
        ...prev,
        businessRulesData: res.data.result,
      }));
    }
  };

  const buildQuestionnaireJson = (name, value, elements, excludeFields) => {
    const filtered = Object.fromEntries(
      Object.entries(elements).filter(([key]) => !excludeFields.includes(key)),
    );

    return {
      ...filtered,
      [name]: value,
    };
  };

  // const updateElement = (name, value) => {
  //   setElements((prev) => ({
  //     ...prev,
  //     [name]: value,
  //   }));
  //   const filteredElements = Object.fromEntries(
  //     Object.entries(elements).filter(([key]) => !excludeFields.includes(key)),
  //   );
  //   let obj = null;
  //   if (questionName.startsWith("page")) {
  //     obj = survey?.pages?.find((item) => item?.name === questionName);
  //     if (obj) {
  //       obj.questionnaireJson = {
  //         ...filteredElements,
  //         [name]: value,
  //       };
  //     }
  //   } else {
  //     obj = survey.pages
  //       ?.flatMap((page) => page.elements || [])
  //       .find((ele) => ele?.id === questionName);
  //     if (obj) {
  //       obj.questionnaireJson = {
  //         ...filteredElements,
  //         [name]: value,
  //       };
  //     }
  //   }
  //   if (obj !== null) {
  //     onSurveyChange({ ...survey, obj });
  //   }
  // };

  const updateElement = (name, value) => {
    setElements((prev) => ({
      ...prev,
      [name]: value,
    }));

    const newQuestionnaireJson = buildQuestionnaireJson(
      name,
      value,
      elements,
      excludeFields,
    );

    const updatedSurvey = {
      ...survey,
      pages: survey.pages.map((page) => {
        // PAGE LEVEL UPDATE
        if (questionName.startsWith("page") && page.name === questionName) {
          return {
            ...page,
            questionnaireJson: {
              ...(page.questionnaireJson || {}),
              ...newQuestionnaireJson,
            },
          };
        }

        // ELEMENT LEVEL UPDATE
        return {
          ...page,
          questionnaireJson: page.questionnaireJson || {},
          elements: page.elements?.map((ele) => {
            if (ele.id === questionName) {
              return {
                ...ele,
                questionnaireJson: {
                  ...(ele.questionnaireJson || {}),
                  ...newQuestionnaireJson,
                },
              };
            }
            return ele;
          }),
        };
      }),
    };

    onSurveyChange(updatedSurvey);
  };

  const renderSelectField = ({
    label,
    id,
    value,
    options = [],
    placeholder = "Select an option",
    onChange,
    valueKey = "value",
    labelKey = "text",
  }) => {
    return (
      <div className="form-group">
        <label className="control-label" htmlFor={id}>
          {label}
        </label>

        <select
          id={id}
          className="form-control"
          value={value}
          onChange={(e) => onChange(e.target.value)}
        >
          <option value="">{placeholder}</option>

          {options.map((item, index) => (
            <>
              {item?.[valueKey] === "" ? (
                <option>1. Default</option>
              ) : (
                <option key={item.id ?? index} value={item[valueKey]}>
                  {index + 1}. {item[labelKey]}
                </option>
              )}
            </>
          ))}
        </select>
      </div>
    );
  };

  const renderInputField = ({
    label,
    id,
    value = "",
    type = "text",
    placeholder = "",
    onChange,
    inputProps = {},
    min = 0,
  }) => {
    return (
      <div className="form-group">
        <label className="control-label" htmlFor={id}>
          {label}
        </label>

        <div className="row">
          <div className="col-sm-12">
            <input
              id={id}
              className="form-control"
              style={{ width: "100%" }}
              min={type === "number" ? min : undefined}
              type={type}
              value={value}
              placeholder={placeholder}
              onChange={(e) => onChange(e.target.value)}
              {...inputProps}
            />
          </div>
        </div>
      </div>
    );
  };

  const renderCheckboxField = ({ label, id, checked = false, onChange }) => {
    return (
      <div
        className="form-group"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: "15px",
        }}
      >
        <label className="control-label" htmlFor={id} style={{ margin: 0 }}>
          {label}
        </label>

        <input
          id={id}
          type="checkbox"
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          style={{ width: "18px", height: "18px", cursor: "pointer" }}
        />
      </div>
    );
  };

  const handleSave = () => {};

  const renderFieldsForPage = () => {
    return (
      <>
        {renderInputField({
          label: "Number",
          id: "number",
          value: number,
          onChange: (val) => updateElement("number", val),
        })}
        {renderInputField({
          label: "Footer Text",
          id: "footerText",
          value: footerText,
          onChange: (val) => updateElement("footerText", val),
        })}
        {PAGE_CONTAINER_OPTIONS?.map((item, index) =>
          renderCheckboxField({
            key: index,
            label: item.label,
            id: `edit-${item.value}`,
            checked: elements[item.value] || false,
            onChange: (val) => updateElement(item.value, val),
          }),
        )}
        {renderFieldsForParaAndHeader()}
      </>
    );
  };

  const renderFieldsForParaAndHeader = () => {
    return (
      <>
        {renderInputField({
          label: "Question Translation Key",
          id: "questionnTranslationKey",
          value: `TranslationKey-${selectedUid || ""}`,
          onChange: () => {},
          inputProps: {
            disabled: true,
          },
        })}

        {renderInputField({
          label: "Translation Key (Current translated value:)",
          id: "translationKeyForEdit",
          value: translationKey,
          onChange: (val) => updateElement("translationKey", val),
        })}
      </>
    );
  };

  const navigateChoices = () => {
    const fieldId = selectedUid;
    const questionDataId = questionnaireId;
    navigate("/study-management/manage-choices", {
      state: {
        fieldId: recieveId,
        questionDataId: questionDataId,
      },
    });
  };

  return (
    <>
      {questionName ? (
        <div className="questionnaire-settings" style={{ padding: 8 }}>
          <div
            className="flex"
            style={{
              padding: "0px",
              marginTop: "-10px",
              marginBottom: "10px",
            }}
          >
            <Tabs
              value={activeTab}
              onChange={updateActiveTab}
              className="tabMinHeight"
            >
              <Tab
                icon={<SettingsIcon />}
                iconPosition="start"
                label="Settings"
              />
              {!questionName?.startsWith("page") && (
                <Tab
                  label="Calculation Control Options"
                  icon={<VisibilityIcon />}
                  iconPosition="start"
                />
              )}
            </Tabs>
          </div>

          {/* Settings Panel */}
          <TabPanel value={activeTab} index={0}>
            {questionName?.startsWith("page") ? (
              <>{renderFieldsForPage()}</>
            ) : (
              <>
                {questionName?.startsWith("header") ||
                questionName?.startsWith("paragraph") ? (
                  <>{renderFieldsForParaAndHeader()}</>
                ) : (
                  <>
                    {renderInputField({
                      label: "Questionnaire Id",
                      id: "questionnaireId",
                      value: `TranslationKey-${questionnaireId || ""}`,
                      onChange: () => {},
                      inputProps: {
                        disabled: true,
                      },
                    })}

                    {renderSelectField({
                      label: "Diary Page",
                      id: "diaryPageSelect",
                      value: selectedDiaryPage,
                      options: diaryPageOptions,
                      placeholder: "Select a DiaryPage",
                      onChange: (val) =>
                        updateElement("selectedDiaryPage", val),
                    })}

                    {renderSelectField({
                      label: "Question Type",
                      id: "questionTypeSelect",
                      value: selectedQuestionType,
                      options: allQuestionsTypeData,
                      placeholder: "Select a Question Type",
                      onChange: (val) =>
                        updateElement("selectedQuestionType", val),
                      labelKey: "name",
                      valueKey: "value",
                    })}

                    <h4
                      style={{
                        textDecoration: "underline",
                        textUnderlineOffset: "4px",
                        marginTop: 20,
                      }}
                    >
                      Language Options
                    </h4>

                    {renderInputField({
                      label: "Question Translation Key",
                      id: "questionnTranslationKey",
                      value: `TranslationKey-${selectedUid || ""}`,
                      onChange: () => {},
                      inputProps: {
                        disabled: true,
                      },
                    })}

                    {renderInputField({
                      label: "Export Display Name",
                      id: "exportDisplayName",
                      value: exportDisplayName,
                      onChange: (val) =>
                        updateElement("exportDisplayName", val),
                    })}

                    {renderInputField({
                      label: "Export Display Order",
                      id: "exportDisplayOrder",
                      value: exportDisplayOrder,
                      type: "number",
                      onChange: (val) =>
                        updateElement("exportDisplayOrder", val),
                    })}

                    {renderSelectField({
                      label: "SAS Data Type",
                      id: "SASDataTypeId",
                      value: selectedSasDataType,
                      options: SAS_DATA_TYPES,
                      placeholder: "Select a SAS Data Type",
                      onChange: (val) =>
                        updateElement("selectedSasDataType", val),
                      labelKey: "key",
                      valueKey: "value",
                    })}

                    {renderInputField({
                      label: "SAS Label",
                      id: "sasLabel",
                      value: sasLabel,
                      onChange: (val) => updateElement("sasLabel", val),
                    })}

                    {renderInputField({
                      label: "SDTM Code",
                      id: "sdtmCode",
                      min: 0,
                      value: sdtmCode,
                      type: "number",
                      onChange: (val) => updateElement("sdtmCode", val),
                    })}

                    {renderInputField({
                      label: "SDTM Text",
                      id: "sdtmText",
                      value: sdtmText,
                      onChange: (val) => updateElement("sdtmText", val),
                    })}

                    {renderInputField({
                      label: "Summary Display Text Key",
                      id: "summaryDisplayTextKey",
                      value: `TranslationKey-${selectedUid}-SummaryText`,
                      onChange: () => {},
                      inputProps: {
                        disabled: true,
                      },
                    })}

                    {renderInputField({
                      label: "Summary Display Text",
                      id: "summaryDisplayText",
                      value: summaryDisplayText,
                      onChange: (val) =>
                        updateElement("summaryDisplayText", val),
                    })}

                    {renderInputField({
                      label: "Description",
                      id: "description",
                      value: description,
                      onChange: (val) => updateElement("description", val),
                    })}

                    {renderInputField({
                      label:
                        " Sequence (This is used to order questionnaires on handheld that are NOT associate with a Visit):",
                      id: "sequenceNumber",
                      min: 0,
                      value: sequenceNumber,
                      type: "number",
                      onChange: (val) => updateElement("sequenceNumber", val),
                    })}

                    {renderInputField({
                      label: "Group Number",
                      id: "groupNumber",
                      value: groupNumber,
                      onChange: (val) => updateElement("groupNumber", val),
                    })}

                    {renderCheckboxField({
                      label: "Active",
                      id: "active",
                      checked: elements.active || false,
                      onChange: (val) => updateElement("active", val),
                    })}

                    {renderSelectField({
                      label: "Patient Attribute Configuration",
                      id: "patientAttributeSelect",
                      value: selectedPatientAttribute,
                      options: patientAttributesData,
                      placeholder: "Select a Patient Attribute Configuration",
                      onChange: (val) =>
                        updateElement("selectedPatientAttribute", val),
                      labelKey: "text",
                      valueKey: "value",
                    })}

                    {renderSelectField({
                      label: "Submit Action Parameters",
                      id: "submitActionSelect",
                      value: selectedSubmitAction,
                      options: submitActionData,
                      placeholder: "Select a Submit Action Parameter",
                      onChange: (val) =>
                        updateElement("selectedSubmitAction", val),
                      labelKey: "text",
                      valueKey: "value",
                    })}

                    {CHOICES_DATA?.map((item, index) =>
                      renderCheckboxField({
                        key: index,
                        label: item.label,
                        id: item.label,
                        checked: elements[item.value] || false,
                        onChange: (val) => updateElement(item.value, val),
                      }),
                    )}

                    {renderSelectField({
                      label: "Language",
                      id: "languageId",
                      value: selectedLanguage,
                      options: allLanguageData,
                      placeholder: "Select Language",
                      onChange: (val) => updateElement("selectedLanguage", val),
                      valueKey: "value",
                      labelKey: "text",
                    })}

                    {renderSelectField({
                      label: "Study File",
                      id: "studyFileId",
                      value: selectedStudyFile,
                      options: STUDY_FILES_OPTIONS,
                      placeholder: "Select Study File",
                      onChange: (val) =>
                        updateElement("selectedStudyFile", val),
                      valueKey: "value",
                      labelKey: "label",
                    })}

                    {renderInputField({
                      label: "Min Value Text Key",
                      id: "minValueTextKey",
                      value: `TranslationKey-${selectedUid}-MinText`,
                      onChange: () => {},
                      inputProps: {
                        disabled: true,
                      },
                    })}

                    {renderInputField({
                      label: "Min Value Display Text",
                      id: "minValueDisplayText",
                      value: minValueTextKeyText,
                      onChange: (val) =>
                        updateElement("minValueTextKeyText", val),
                    })}

                    {renderInputField({
                      label: "Max Value Text Key",
                      id: "maxValueTextKey",
                      value: `TranslationKey-${selectedUid}-MaxText`,
                      onChange: () => {},
                      inputProps: {
                        disabled: true,
                      },
                    })}

                    {renderInputField({
                      label: "Max Value Display Text",
                      id: "maxValueDisplayText",
                      value: maxValueDisplayText,
                      onChange: (val) =>
                        updateElement("maxValueDisplayText", val),
                    })}

                    {renderCheckboxField({
                      label: "Land Scape Orientation",
                      id: "landScapeOrientation",
                      checked: landScapeOrientation || false,
                      onChange: (val) =>
                        updateElement("landScapeOrientation", val),
                    })}

                    {renderInputField({
                      label: "Input Display Text",
                      id: "inputDisplayText",
                      value: inputDisplayText,
                      onChange: (val) => updateElement("inputDisplayText", val),
                    })}

                    {renderInputField({
                      label: "Id",
                      id: "questionId",
                      value: `question-${selectedUid || ""}`,
                      onChange: () => {},
                      inputProps: {
                        disabled: true,
                      },
                    })}

                    {renderInputField({
                      label: "Translation Key (Current translated value:)",
                      id: "translationKeyForEdit",
                      value: translationKey,
                      onChange: (val) => updateElement("translationKey", val),
                    })}

                    <div className="form-group">
                      <div className="row" style={{ marginTop: "10px" }}>
                        <div className="col-sm-12">
                          <input
                            className="form-control"
                            style={{ width: "50%" }}
                            value="Edit Translation"
                            type="button"
                            id="EditTranslation"
                            onClick={() => {}}
                          />
                        </div>
                      </div>
                    </div>

                    {renderInputField({
                      label: "Internal Name",
                      id: "internalName",
                      value: internalName,
                      onChange: (val) => updateElement("internalName", val),
                    })}

                    {renderSelectField({
                      label: "Questionnaire Type Id",
                      id: "questionnaireTypeId",
                      value: selectedQuestionnaireType,
                      options: questionnaireTypeData
                        ? [questionnaireTypeData]
                        : [],
                      onChange: (val) =>
                        updateElement("selectedQuestionnaireType", val),
                      valueKey: "id",
                      labelKey: "name",
                    })}

                    {BUSINESS_DATA?.map((item, index) =>
                      renderCheckboxField({
                        key: index,
                        label: item.label,
                        id: item.label,
                        checked: elements[item.value] || false,
                        onChange: (val) => updateElement(item.value, val),
                      }),
                    )}

                    {renderSelectField({
                      label: "Visible Business Rule Id",
                      id: "visibleBusinessRuleId",
                      value: selectedBusinessRule,
                      options: businessRulesData,
                      placeholder: "Select A Property",
                      onChange: (val) =>
                        updateElement("selectedBusinessRule", val),
                      valueKey: "id",
                      labelKey: "name",
                    })}

                    {renderSelectField({
                      label: "Open Ended Business Rule Id",
                      id: "openEndedBusinessRuleId",
                      value: selectedOpenEnded,
                      options: OPEN_ENDED_OPTIONS,
                      placeholder: "Select Option",
                      onChange: (val) =>
                        updateElement("selectedOpenEnded", val),
                      valueKey: "value",
                      labelKey: "label",
                    })}

                    {/* Manage choices */}
                    {recieveId && showManageChoices && (
                      <>
                        <div className="row">
                          <div className="col-sm-12">
                            <button
                              className="form-control"
                              style={{ width: "50%" }}
                              value="Manage Choices"
                              type="button"
                              id="manageChoices"
                              onClick={navigateChoices}
                            >
                              Manage Choices
                            </button>
                          </div>
                        </div>
                        <div className="mb-10">
                          <ManageChoice
                            state={{
                              fieldId: recieveId,
                              questionDataId: questionnaireId,
                            }}
                          />
                        </div>
                      </>
                    )}

                    {renderSelectField({
                      label: "Choice Display Property",
                      id: "choiceDisplayTypeId",
                      value: selectedDisplayProperty,
                      options: allChoicesData,
                      placeholder: "Select A Property",
                      onChange: (val) =>
                        updateElement("selectedDisplayProperty", val),
                      valueKey: "value",
                      labelKey: "text",
                    })}

                    {renderSelectField({
                      label:
                        "Enable Visit Questionnaire Id (This diary will not be available until the specified Visit / Questionnaire is completed).",
                      id: "enableVisitQuestionnaireId",
                      value: selectedEnabledQuestionnaire,
                      options: OPEN_ENDED_OPTIONS,
                      placeholder: "Select Option",
                      onChange: (val) =>
                        updateElement("selectedEnabledQuestionnaire", val),
                      valueKey: "value",
                      labelKey: "label",
                    })}

                    {renderInputField({
                      label:
                        "Previous Days Entry (This indicates how many days previous MUST be completed in the scale. 0 indicates just today. This would typically NOT have an available businessRule Id).",
                      id: "previousDaysEntryId",
                      type: "number",
                      value: previousDayEntry,
                      onChange: (val) => updateElement("previousDayEntry", val),
                      inputProps: {
                        min: 0,
                      },
                    })}

                    {renderInputField({
                      label:
                        "Previous Days Edit (This indicates how many days previous can be edited. 0 indicates just today. This would typically NOT have an available businessRule Id. It is directly related to the Previous Days Entry and would not typically be greater than that value).",
                      id: "previousDaysEditId",
                      type: "number",
                      value: previousDayEdit,
                      onChange: (val) => updateElement("previousDayEdit", val),
                      inputProps: {
                        min: 0,
                      },
                    })}

                    {EDIT_OPTIONS?.map((item, index) =>
                      renderCheckboxField({
                        key: index,
                        label: item.label,
                        id: `edit-${item.value}`,
                        checked: elements[item.value] || false,
                        onChange: (val) => updateElement(item.value, val),
                      }),
                    )}
                  </>
                )}
              </>
            )}
          </TabPanel>

          {/* Controls Options Panel */}
          <TabPanel value={activeTab} index={1}>
            <CalculationControlComp
              json={survey}
              setJson={onSurveyChange}
              selectedQuestion={questionName}
              setActiveTab={setActiveTab}
            />
          </TabPanel>
        </div>
      ) : (
        <div
          style={{
            padding: "10px",
            textAlign:"center"
          }}
        >
          <strong>Select Any Question to continue.</strong>
        </div>
      )}
    </>
  );
}
